/* eslint-disable jsdoc/require-returns */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable jsdoc/require-param */
/* eslint-disable valid-jsdoc */
/**
 * Defines the behavior of a pyramid series
 */
import { removeElement } from '@syncfusion/ej2-svg-base';
import { appendChildElement } from '../../common/utils/helper';
import { TriangularBase } from './triangular-base';
/**
 * PyramidSeries module used to render `Pyramid` Series.
 */
export class PyramidSeries extends TriangularBase {
    /**
     * Defines the path of a pyramid segment
     */
    getSegmentData(point, series, chart) {
        const area = series.triangleSize;
        //top of th series
        const seriesTop = chart.initialClipRect.y + (chart.initialClipRect.height - area.height) / 2;
        //consider, if the point is exploded
        const offset = 0;
        const extraSpace = (chart.initialClipRect.width - series.triangleSize.width) / 2;
        const emptySpaceAtLeft = extraSpace + chart.initialClipRect.x;
        //top and bottom
        let top = point.yRatio;
        let bottom = point.yRatio + point.heightRatio;
        //width of the top and bottom edge
        const topRadius = 0.5 * (1 - point.yRatio);
        const bottomRadius = 0.5 * (1 - bottom);
        top += seriesTop / area.height;
        bottom += seriesTop / area.height;
        const line1 = {
            x: emptySpaceAtLeft + offset + topRadius * area.width,
            y: top * area.height
        };
        const line2 = {
            x: emptySpaceAtLeft + offset + (1 - topRadius) * area.width,
            y: top * area.height
        };
        const line3 = {
            x: emptySpaceAtLeft + offset + (1 - bottomRadius) * area.width,
            y: bottom * area.height
        };
        const line4 = {
            x: emptySpaceAtLeft + offset + bottomRadius * area.width,
            y: bottom * area.height
        };
        const polygon = [line1, line2, line3, line4];
        this.setLabelLocation(series, point, polygon);
        const direction = this.findPath(polygon);
        return direction;
    }
    /**
     * Initializes the size of the pyramid segments
     *
     * @private
     */
    initializeSizeRatio(points, series) {
        if (series.pyramidMode === 'Linear') {
            super.initializeSizeRatio(points, series, true);
        }
        else {
            this.calculateSurfaceSegments(series);
        }
    }
    /**
     * Defines the size of the pyramid segments, the surface of that will reflect the values
     */
    calculateSurfaceSegments(series) {
        const count = series.points.length;
        const sumOfValues = series.sumOfPoints;
        const y = [];
        const height = [];
        const gapRatio = Math.min(0, Math.max(series.gapRatio, 1));
        const gapHeight = gapRatio / (count - 1);
        const preSum = this.getSurfaceHeight(0, sumOfValues);
        let currY = 0;
        for (let i = 0; i < count; i++) {
            if (series.points[i].visible) {
                y[i] = currY;
                height[i] = this.getSurfaceHeight(currY, Math.abs(series.points[i].y));
                currY += height[i] + gapHeight * preSum;
            }
        }
        const coef = 1 / (currY - gapHeight * preSum);
        for (let i = 0; i < count; i++) {
            if (series.points[i].visible) {
                series.points[i].yRatio = coef * y[i];
                series.points[i].heightRatio = coef * height[i];
            }
        }
    }
    /**
     * Finds the height of pyramid segment
     */
    getSurfaceHeight(y, surface) {
        const result = this.solveQuadraticEquation(1, 2 * y, -surface);
        return result;
    }
    /**
     * Solves quadratic equation
     */
    solveQuadraticEquation(a, b, c) {
        let root1;
        let root2;
        const d = b * b - 4 * a * c;
        if (d >= 0) {
            const sd = Math.sqrt(d);
            root1 = (-b - sd) / (2 * a);
            root2 = (-b + sd) / (2 * a);
            return Math.max(root1, root2);
        }
        return 0;
    }
    /**
     * Renders a pyramid segment
     */
    renderPoint(point, series, chart, options, seriesGroup, redraw) {
        if (!point.visible) {
            removeElement(options.id);
            return null;
        }
        options.d = this.getSegmentData(point, series, chart);
        point.midAngle = 0;
        const element = chart.renderer.drawPath(options);
        element.setAttribute('role', 'img');
        element.setAttribute('tabindex', point.index === 0 ? '0' : '');
        element.setAttribute('aria-label', (point.x + ': ' + point.y + '%. ' + series.name));
        appendChildElement(false, seriesGroup, element, redraw);
        if (point.isExplode) {
            chart.accBaseModule.explodePoints(point.index, chart, true);
        }
    }
    /**
     * To get the module name of the Pyramid series.
     */
    getModuleName() {
        return 'PyramidSeries';
    }
    /**
     * To destroy the pyramid series
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the pyramid series
         */
    }
}
